import { m } from "@/paraglide/messages.js";
import { LegalField, legalEntity, legalRegistration } from "@complete-athlete/enums";

/**
 * What the documents' placeholders are filled with, from the one place these details live
 * (`legalEntity`). A detail not settled yet reads as a marked blank.
 */
export const legalFacts = () => {
  const email = legalEntity[LegalField.EMAIL];

  return {
    operator: legalEntity[LegalField.COMPANY] ?? m.legal_blank_operator(),
    address: legalEntity[LegalField.ADDRESS] ?? m.legal_blank_address(),
    registration: legalRegistration() ?? m.legal_blank_registration(),
    email: email ? `[${email}](mailto:${email})` : m.legal_blank_operator(),
    dmca_agent: legalEntity[LegalField.DMCA_AGENT] ?? m.legal_blank_dmca_agent(),
  };
};
